<template>
  <component
    :is="isLink ? Link : 'span'"
    :href="isLink ? props.link.url : null"
    :preserve-state="props.preserveState"
    :preserve-scroll="props.preserveScroll"
    :only="props.only"
    class="
      relative
      inline-flex
      items-center
      px-4
      py-2
      border
      text-sm
      font-medium
    "
    :class="classes"
  >
    {{ label }}
  </component>
</template>

<script setup>
import { Link } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'
const props = defineProps({
  link: Object,
  preserveState: Boolean,
  preserveScroll: Boolean,
  only: Array,
})

const isLink = computed(() => props.link.url && !props.link.active)

const classes = computed(() => {
  if (props.link.active)
    return 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 dark:bg-indigo-900 dark:text-indigo-100 dark:border-indigo-300'
  else if (props.link.url)
    return 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-gray-300 dark:hover:text-gray-100'
  else
    return 'bg-white border-gray-300 text-gray-700 dark:bg-gray-600 dark:text-gray-200'
})

const label = computed(() =>
  !props.link.active && !props.link.url ? '...' : props.link.label
)
</script>
